const chartPalette: string[] = [
  '#F2755F',
  '#9CD866',
  '#075064',
  '#FFA156',
  '#4CBEAC',
  '#00836E',
  '#C9472F',
  '#B48A2A',
  '#0B85A7',
  '#F6C75F',
  '#6F4E7B',
  '#62B815',
  '#DD6200',
];

export default chartPalette;
